export default __webpack_public_path__ + "static/media/vc1.6428fbaa.svg";